// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-33F8j","loading":"index-loading-DhaTJ"};